import angular, { version } from 'angular';
import moment from 'moment';
import URLS from 'Helpers/urls';

(function() {
    'use strict';

    angular.module('app').component('applicationDetailModal', {
        template: require('./application-detail-modal.html'),
        controller: Ctrl,
        controllerAs: 'vm',
        bindings: {
            modalInstance: '<',
            resolve: '<'
        }
    });

    Ctrl.$inject = [
        '$scope',
        '$cookies',
        '$timeout',
        'UploadService',
        'logger',
        'SessionService',
        'QueryService',
        'SweetAlert'
    ];

    function Ctrl($scope, $cookies, $timeout, UploadService, logger, SessionService, QueryService, SweetAlert) {
        var vm = this;
        vm.content = null;
        vm.user = SessionService.getUser();

        vm.save_local = save_local;
        vm.upload_audio = upload_audio;
        vm.upload_audio2 = upload_audio2;
        vm.close = close;
        vm.data = localStorage.getItem('applicationdata')? JSON.parse(localStorage.getItem('applicationdata')): {};

        navigator.getUserMedia = ( navigator.getUserMedia ||
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.msGetUserMedia);

        vm.days = ['Su', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];
        vm.times = [6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23];

        setTimeout(() => {
            vm.page = vm.resolve.Modal.page;
            vm.title = vm.resolve.Modal.title;
            vm.data = vm.resolve.Modal.data;

            if(!vm.data.availability){
                vm.data.availability = [];
    
                vm.days.forEach((day, x) => {
                    vm.data.availability[x] = [];
                    vm.times.forEach((time,y) => {
                        vm.data.availability[x][y] = { value: false, time: time, day:day };
                    });
                });
    
            }else{
                vm.data.availability = JSON.parse(vm.data.availability);

                
                vm.days.forEach((day, x) => {
                    vm.times.forEach((time, y) => {
                        vm.data.availability[x][y] = { time, day, value: vm.data.availability[x][y] }
                    });
                });
            }

            if(vm.page == 3){
                if(!vm.data.tags){
                    vm.data.tags = {};
                } else {
                    const tags = vm.data.tags.split(',');
                    vm.data.tags = {};
                    tags.forEach(tag => vm.data.tags[tag] = true);
                    console.log(vm.data.tags);
                }
            }

            vm.application_audio = vm.data.application_audio
            vm.audio_answer1 = vm.data.audio_answer1;
            vm.audio_answer2 = vm.data.audio_answer2;
            vm.audio_answer3 = vm.data.audio_answer3;
            $scope.$apply();
            
        });

        vm.basic_info = [{
            name: 'Nickname',
            key: 'name'
        },{
            name: 'Phone #',
            key: 'phone',
            placeholder: '+63 939 626 9235'
        },{
            name: 'Email',
            key: 'email'
        },{
            name: 'Kakao ID',
            key: 'kakao_id'
        },{
            name: 'Electric Service Provider',
            key: 'e_esp'
        },{
            name: 'Internet Service Provider',
            key: 'e_isp'
        },{
            name: 'Street',
            key: 'e_street'
        },{
            name: 'More Details',
            key: 'e_street_more'
        },{
            name: 'City',
            key: 'e_city'
        }, {
            name: 'Zipcode',
            key: 'e_zipcode'
        }, {
            name: 'Experience',
            key: 'years_of_experience'
        },{
            name: 'Expertise',
            key: 'expertise'
        }];

        vm.quiz = [{
            name: '1. A <span class="underline">typical Filipino</span><sub class="subscript">(A)</sub> dish, Adobo, <span class="underline">consisting</span><sub class="subscript">(B)</sub> of stir-fried garlic, soy sauce and vinegar as its main source <span class="underline">of</span><sub class="subscript">(C)</sub> flavor, <span class="underline">and</span><sub class="subscript">(D)</sub> pork or chicken as the main part of the dish.',
            index: 0,
        },{
            name: '2. Each year, the Magical Egg, a <span class="underline">mass</span><sub class="subscript">(A)</sub> distributor of chicken eggs, <span class="underline">uses</span><sub class="subscript">(B)</sub> millions of pesos in advertising revenue <span class="underline">annually</span><sub class="subscript">(C)</sub>, but it is rumored that their operations <span class="underline">may</span><sub class="subscript">(D)</sub> stop due to undisclosed circumstances.',                
            index: 1,
        },{
            name: '3. Some industries in Russia <span class="underline">are</span><sub class="subscript">(A)</sub> shifting to eco-friendly alternatives, <span class="underline">which reduces</span><sub class="subscript">(B)</sub> <span class="underline">both</span><sub class="subscript">(C)</sub> air and water pollution <span class="underline">in</span><sub class="subscript">(D)</sub> their vicinity.',
            index: 2,
        },{
            name: '4. PLDT is currently one of the most popular <span class="underline">of all</span><sub class="subscript">(A)</sub> internet service providers in the Philippines, <span class="underline">and is</span><sub class="subscript">(B)</sub> found not only in urban areas <span class="underline">and</span><sub class="subscript">(C)</sub> also in rural <span class="underline">or</span><sub class="subscript">(D)</sub> depopulated areas.',
            index: 3,
        }];

        vm.years_of_experience = [
            'No experience',
            'Less than a year',
            '1 - 2 years',
            '3 - 5 years',
            '5 years or more'
        ];

        vm.tags = [
            'OPIc',
            'TOEFL',
            'TOEIC',
            'Business English',
            'English for Traveling',
            'English for Kids',
            'Freetalking',
            'IELTS',
            'Job Interview Training'
        ].map(s => { return { text: s} });

        vm.upload_image = upload_image;

        vm.save_tags = ()=>{
            console.log(vm.data);
            vm.save_local();
        }

        vm.get_tags = ()=>{

            vm.loading = true;
            var request = {
                method: 'GET',
                route: URLS.base + `/tag`,
                cache: false
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        const data = response.data.data;
                        console.log(data);
                        vm.tags = data.items;

                    },
                    function(error) {}
                )
                .finally(function() { vm.loading = false; }
            );
        }

        vm.get_tags();


        

        vm.click_time = (_time)=>{
            console.log(vm.data.availability);
            let v = true;
            vm.days.forEach((day, x) => {
                vm.times.forEach((time, y) => {
                    
                    if(time == _time){
                        if(vm.data.availability[x][y].value){
                            v = false;
                        }
                    }

                });
            });

            vm.days.forEach((day, x) => {
                vm.times.forEach((time, y) => {
                    if(time == _time){
                        console.log(vm.data.availability[x][y], x, y ,vm.data);
                        vm.data.availability[x][y].value = !!v;
                    }
                });
            });
            save_local();

        }

        vm.click_day = (_day)=>{
            
            let v = true;
            vm.days.forEach((day, x) => {
                vm.times.forEach((time, y) => {
                    if(day == _day){
                        if(vm.data.availability[x][y].value){
                            v = false;
                        }
                    }

                });
            });

            vm.days.forEach((day, x) => {
                vm.times.forEach((time, y) => {
                    
                    if(day == _day){
                        vm.data.availability[x][y].value = !!v;
                    }

                });
            });

            save_local();
        }

        
        // record stuff
        vm.chunks = [];
        
        navigator.getUserMedia ({ audio: true }, ()=>{

            navigator.mediaDevices.enumerateDevices()
            .then(function(devices) {
                const d = devices.filter(s => s.kind == 'audioinput');
                console.log(d);

                d.forEach(_d => vm.devices.push(_d));
                vm.selected_device = '0';
                $scope.$apply();
            });
        }, ()=>{

        });

        init_video();
        function init_video(){

            navigator.mediaDevices.getUserMedia({
                audio: true,
                video: true
            }).then((stream) => {
                const video_stream = new MediaRecorder(stream);
                vm.video_stream = video_stream;

                var preview = document.getElementById('video_preview')
                preview.srcObject = stream

                video_stream.ondataavailable = function(e) {
                    vm.video_chunks.push(e.data);
                }
                
                video_stream.onstop = () => {
                    
                    var video = document.getElementById('video_player');
                    video.setAttribute('controls', '');
                    video.controls = true;
                    var blob = new Blob(vm.video_chunks, { 'type' : 'video/mp4' });

                    var videoURL = URL.createObjectURL(blob);
                    video.src = videoURL;
                    setTimeout(()=>{
                        video.pause();
                    }, 200);

                    vm.has_video = true;
                    $scope.$apply();
                    const file = blobToFile(blob,'test.mp4');

                    UploadService.upload(
                        file,
                        'video/mp4',
                        { path: 'application_audio', type: file.type },
                        location => {
                            vm.application_audio = location;
                            save_local();
                        }
                    );

                    function blobToFile(theBlob, fileName){
                        return new File([theBlob], fileName, {lastModified: new Date(), type: theBlob.type})
                    }
                }
            });
        }

        vm.record_video_start = () => {
            vm.recording_video = true;
            vm.video_chunks = [];
            vm.video_stream.start();
            vm.has_video = false;
        }

        vm.record_video_stop = () => {
            vm.recording_video = false;
            vm.video_stream.stop();
        }
        
        init_record('audio_answer1');
        init_record('audio_answer2');
        init_record('audio_answer3');
        init_record('application_audio');
        function init_record(i){
            vm.devices = [];
            vm.selected_device = 0;
            vm[i+'_mode'] = 'stopped';
        }

        vm.record_button_clicked = record_button_clicked;
        vm.start_record = start_record;
        vm.stop_record = stop_record;
        function start_record(i, video){

            const deviceId = vm.devices[vm.selected_device].deviceId;

            window.AudioContext = window.AudioContext || window.webkitAudioContext;

            vm.context = new AudioContext();

            var userMedia_params = { 
                audio: { deviceId }
            };

            if(video){
                userMedia_params.video = true
            }

            navigator.mediaDevices.getUserMedia(userMedia_params).then((stream) => {
                
                vm[i + '_recorder'] = new MediaRecorder(stream);
                vm[i + '_recorder'].start();


                vm[i + '_recorder'].ondataavailable = function(e) {
                    vm.chunks.push(e.data);
                }
                
                vm[i + '_recorder'].onstop = () => {

                    var audio = document.getElementById('audioplayer_'+i);
                    audio.setAttribute('controls', '');
                    audio.controls = true;
                    var blob = new Blob(vm.chunks, { 'type' : 'audio/ogg; codecs=opus' });
                    vm.chunks = [];

                    var audioURL = URL.createObjectURL(blob);
                    audio.src = audioURL;
                    // audio.play();
                    setTimeout(()=>{
                        audio.pause();
                    }, 200);

                    const file = blobToFile(blob,'test.ogg');

                    UploadService.upload(
                        file,
                        'audio/ogg; codecs=opus',
                        { path: 'application_audio', type: file.type },
                        location => {
                            console.log(i, location);
                            vm[i] = location;
                            save_local();
                        }
                    );

                }
                
            });

            vm[i + '_recording_start'] = new Date();
            set_timer(i);


            function blobToFile(theBlob, fileName){
                return new File([theBlob], fileName, {lastModified: new Date(), type: theBlob.type})
            }
        }

        function stop_record(i){
            vm[i + '_recorder'].stop();
            vm[i + '_mode'] = 'stopped';
            vm[i + '_recorded'] = 1;
        }

        function record_button_clicked(i, video){

            if(vm[i]){
                remove_audio(i);

            }else{
                start();
            }

            function start(){

                if(vm[i+'_mode'] === 'stopped'){
                    vm[i+'_mode'] = 'recording';
                    start_record(i, video);
                } else

                if(vm[i+'_mode'] === 'recording'){
                    vm[i+'_mode'] = 'stopped';
                    stop_record(i, video);
                }

                console.log(i);
            }

        }

        function set_timer(i){
            const seconds = parseInt((new Date() - vm[i + '_recording_start'])/1000);
        
            vm[i + '_duration'] = (parseInt(seconds/60)+'').padStart(2, '0') + ':' + (seconds % 60 + '').padStart(2, '0');
            setTimeout(()=>{
                $scope.$apply();
                if(vm[i + '_mode'] === 'recording'){
                    set_timer(i);
                }
            }, 1000);

        }
        // end record

        function upload_image(file, index){

            UploadService.upload(
                file,
                file.type,
                { path: 'application_profile', type: file.type },
                location => {
                    vm.data['profile_' + index] = location;
                    vm.save_local();
                }
            );

        }


        function upload_audio(file){

            UploadService.upload(
                file,
                file.type,
                { path: 'application_profile', type: file.type },
                location => {
                    vm.data['profile_' + index] = location;
                    vm.save_local();
                }
            );

        }

        function upload_audio2(file){

            UploadService.upload(
                file,
                file.type,
                { path: 'application_profile', type: file.type },
                location => {
                    vm.data.audio_introduction = location;
                    vm.save_local();
                }
            );

        }

        // save local
        function save_local(){
            // localStorage.setItem('applicationdata', JSON.stringify(vm.data));
        }

        // controls
        function close(){
            vm.modalInstance.close();
        }

        vm.remove_audio=remove_audio;
        function remove_audio(i){
            function start(){

                vm[i + '_recording_start'] = new Date();
                set_timer();
                
                var audio = document.getElementById('audioplayer_' + i);
                audio.setAttribute('controls', '');
                audio.controls = false;
                
                vm[i + '_duration'] = 0;
                vm[i] = null;

                vm.save_local();
            }

            SweetAlert.swal(
                {
                    title: 'Are you sure that you want to delete the previous recording?',
                    text: ``,
                    type: 'warning',
                    confirmButtonText: 'Proceed',
                    cancelButtonText: 'Cancel',
                    showCancelButton: true,
                    closeOnConfirm: true,
                    html: true,
                    closeOnCancel: true
                },
                function(proceed) {
                    if (proceed) {
                        start();
                    }
                }
            );
        }

        vm.apply = apply;
        //apply
        function apply(){
            const data = { 
                ...vm.data, 
                application_audio: vm.application_audio,
                audio_answer1: vm.audio_answer1,
                audio_answer2: vm.audio_answer2,
                audio_answer3: vm.audio_answer3
            };

            const quiz = data.quiz;

            if(vm.data.quiz){
                data.quiz = JSON.stringify(vm.data.quiz);
            }
            
            data.profile_card = [ data.profile_1, data.profile_2, data.profile_3 ].join('###');

            

            if(vm.data.availability){
                data.availability = JSON.parse(JSON.stringify(vm.data.availability));
                vm.days.forEach((day, x) => {
                    vm.times.forEach((time, y) => {
                        data.availability[x][y] = data.availability[x][y].value;
                    });
                });
                data.availability = JSON.stringify(data.availability);
            }

            if(data.tags){

                data.tags = Object.keys(data.tags)
                .filter(k => data.tags[k])
                .map(k => {
                    const sss = vm.tags.find(t => t.english_text === k)
                    if(sss){
                        return sss.id
                    }else{
                        return ''
                    }
                });
            }

            // console.log(Object.keys(vm));
            // console.log(vm.audio_answer1);
            // console.log(vm.audio_answer2);
            // console.log(vm.audio_answer3);

            const required = [
                // { key:"written_input",         page: 0, label: 'essay' },
                { key:"application_audio",     page: 0, label: 'passage reading' },
                { key:"audio_answer1",         page: 1, label: 'answer for #1' },
                { key:"audio_answer2",         page: 1, label: 'answer for #2' },
                { key:"audio_answer3",         page: 1, label: 'answer for #3' },
                { key:"name",                  page: 2, label: 'name' },
                { key:"phone",                 page: 2, label: 'phone number' },
                { key:"email",                 page: 2, label: 'email address' },
                { key:"kakao_id",              page: 2, label: 'kakao ID' },
                { key:"e_esp",                 page: 2, label: 'electric service provider' },
                { key:"e_isp",                 page: 2, label: 'internet service provider' },
                { key:"e_street",              page: 2, label: 'street' },
                { key:"e_city",                page: 2, label: 'city' },
                { key:"e_zipcode",             page: 2, label: 'zipcode' },
                // { key:"e_street_more",         page: 3, label: 'additional address details' },
                { key:"years_of_experience",   page: 2, label: 'years of experience' },
                { key:"tags",                  page: 2, label: 'expertise' },
                { key:"availability",          page: 3, label: 'available schedule' },
                { key:"profile_card",          page: 4, label: 'profile picture' },
                { key:"about_me",              page: 4, label: 'written introduction' },
                { key:"audio_introduction",    page: 4, label: 'audio introduction' },
                { key:"application_audio",     page: 5, label: 'video interview' },
            ];
            
            
            const _data = {};
            const _required = required.filter(d => d.page == vm.page);
            console.log(_required, vm.page);
            _required.forEach(r => {
                _data[r.key] = data[r.key];
                if(!data[r.key]){
                    _data[r.key] = 'nullnull';
                }
            });

            console.log(_required);

            vm.loading = true;
            var request = {
                method: 'PUT',
                body: _data,
                route: `${ URLS.base }/teacher/${ vm.user.id }`,
                cache: false
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        close();
                        logger.success('Details Saved!');
                    },
                    function(error) {}
                )
                .finally(function() { vm.loading = false; }
            );

        }
        

        vm.seek_audio = seek_audio;
        vm.play_audio = play_audio;
        vm.is_audio_playing = is_audio_playing;
        setup_audio();
        function setup_audio(){
            vm.q1seek = 0;
            vm.q2seek = 0;
            vm.q3seek = 0;
        }

        vm.qseektimers = {};
        function play_audio(id){
            const audio = document.getElementById(id);
            if(audio){
                if(audio.paused){
                    audio.play();

                    vm.qseektimers[id] = setInterval(() => {
                        const duration = audio.duration;
                        const currentTime = audio.currentTime;

                        // vm[id+'seek'] =  currentTime / duration * 100;
                        const seeker = document.getElementById(id + 'seeker');
                        seeker.value = currentTime / duration * 100;
                        
                        $scope.$apply();
                    }, 100);
                }else{
                    clearInterval(vm.qseektimers[id])
                    audio.pause();
                }
            }
        }


        function is_audio_playing(id){
            const audio = document.getElementById(id);
            return !audio.paused;
        }

        function seek_audio(id, seek, sub){
            const seeker = document.getElementById(id + 'seeker'); 
            const audio = document.getElementById(id);
            if(audio && audio.currentTime){

                if(sub){
                    audio.currentTime = audio.currentTime + sub;
                    seeker.value = audio.currentTime / audio.duration * 100;
                }else{
                    const duration = audio.duration;
                    const percent = vm[seek] / 100;
                    audio.currentTime = percent * duration;
                }
            }
        }
    }
})();



// WEBPACK FOOTER //
// ./src/app/components/application-details/application-detail-modal.component.js